import PropTypes from 'prop-types'

export default function Tabs({ tabsData, selectedTab, handleTabSelection }) {
  return (
    <>
      <div className='tab-container' id='tabs'>
        {tabsData.map((tab, index) => (
          <div
            key={index}
            className={`tab ${
              selectedTab === tab.label.toLowerCase() ? 'active' : ''
            }`}
            onClick={() => handleTabSelection(tab)}
          >
            {tab.label}
          </div>
        ))}
      </div>
    </>
  )
}

Tabs.propTypes = {
  tabsData: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedTab: PropTypes.string,
  handleTabSelection: PropTypes.func.isRequired,
}
